import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertCircle, ArrowRight } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

interface UrgencySectionProps {
  onStartClick?: () => void;
}

const UrgencySection: React.FC<UrgencySectionProps> = ({ onStartClick }) => {
  return (
    <section className="py-16 bg-gradient-to-r from-red-50 to-orange-50 border-y border-red-100">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          {/* Alert Header */}
          <div className="flex justify-center mb-6">
            <Badge className="bg-red-100 text-red-800 border-red-200 px-4 py-2">
              <AlertCircle className="w-4 h-4 mr-2 inline" />
              Limited Time Offer
            </Badge>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            Try Munger.ai Risk-Free
          </h2>

          {/* Simple Offer */}
          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
              <div className="space-y-4">
                <div className="flex items-center justify-center gap-2 text-lg">
                  <Clock className="w-5 h-5 text-blue-600" />
                  <span className="font-semibold text-gray-900">3-Day Free Trial</span>
                </div>
                <p className="text-gray-700">
                  See if Munger.ai works for your business before paying anything
                </p>
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-sm text-gray-600">
                    Cancel anytime • Real support available
                  </p>
                </div>
                
                <div className="pt-4">
                  <Button 
                    className="bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 px-6 py-2 font-semibold"
                    onClick={onStartClick}
                  >
                    Start 3-Day Trial
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default UrgencySection; 